export const baseProjectTag = 'baseProject:';
